import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	pageLabel: {
		id: 'confluence-data-center-search-result.document.pageLabel',
		defaultMessage: 'Page',
		description: 'Label for a DC document page search result.',
	},
	spaceLabel: {
		id: 'confluence-data-center-search-result.document.spaceLabel',
		defaultMessage: 'Space',
		description: 'Label for a DC document space search result.',
	},
	blogpostLabel: {
		id: 'confluence-data-center-search-result.document.blogpostLabel',
		defaultMessage: 'Blog Post',
		description: 'Label for a DC document blog post search result.',
	},
	commentLabel: {
		id: 'confluence-data-center-search-result.document.commentLabel',
		defaultMessage: 'Comment',
		description: 'Label for a DC document comment search result.',
	},
	attachmentLabel: {
		id: 'confluence-data-center-search-result.document.attachmentLabel',
		defaultMessage: 'Attachment',
		description: 'Label for a DC document attachment search result.',
	},
});
